import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  content: {
    display: 'flex',
    flexFlow: 'column nowrap',
  },

  trainings: {
    display: 'flex',
    flex: '1',
  },

  list: {
    flex: '1',
    display: 'flex',
    flexFlow: 'column nowrap',
  },

  sidePanel: {
    display: 'flex',
    flexFlow: 'column nowrap',
    minWidth: '25rem',
    width: '30%',
    marginLeft: '1.3rem',
    paddingLeft: '1.2rem',
    position: 'relative',
    borderLeft: '.0631rem solid #e8e8e8',
  },

  flex: {
    display: 'flex',
  },

  marginRightSm: {
    marginRight: '.5rem',
  },
})

export default useStyles
